import { render, staticRenderFns } from "./hba1c.vue?vue&type=template&id=533bfa44&scoped=true"
import script from "./hba1c.vue?vue&type=script&lang=js"
export * from "./hba1c.vue?vue&type=script&lang=js"
import style0 from "./hba1c.vue?vue&type=style&index=0&id=533bfa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533bfa44",
  null
  
)

export default component.exports